import { create } from 'zustand';
import { SearchTransitionSource } from '@/api/types/ads.types';

interface SearchStore {
  isSuggestionsOpened: boolean;
  setIsSuggestionsOpened: (value: boolean) => void;
  searchTransitionSource: SearchTransitionSource | null;
  setSearchTransitionSource: (value: SearchTransitionSource | null) => void;
}

export const useSearchStore = create<SearchStore>(set => ({
  isSuggestionsOpened: false,
  setIsSuggestionsOpened: value => set({ isSuggestionsOpened: value }),
  searchTransitionSource: null,
  setSearchTransitionSource: value => set({ searchTransitionSource: value }),
}));
